/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReturnInfoVo1
 */
export interface ReturnInfoVo1 {
    /**
     * 收货人姓名
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    receiverName?: string;
    /**
     * 收货人手机号
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    mobileNo?: string;
    /**
     * 收货人邮政编码
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    zip?: string;
    /**
     * 收货人地址
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    address?: string;
    /**
     * 收货人详细地址
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    addressDetail?: string;
    /**
     * 退货备注
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    remark?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof ReturnInfoVo1
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof ReturnInfoVo1
     */
    returnFetchGoodsDate?: string;
}

/**
 * Check if a given object implements the ReturnInfoVo1 interface.
 */
export function instanceOfReturnInfoVo1(value: object): value is ReturnInfoVo1 {
    return true;
}

export function ReturnInfoVo1FromJSON(json: any): ReturnInfoVo1 {
    return ReturnInfoVo1FromJSONTyped(json, false);
}

export function ReturnInfoVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnInfoVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
    };
}

export function ReturnInfoVo1ToJSON(json: any): ReturnInfoVo1 {
    return ReturnInfoVo1ToJSONTyped(json, false);
}

export function ReturnInfoVo1ToJSONTyped(value?: ReturnInfoVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'remark': value['remark'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
    };
}

